import get from './get'
import update from './update'
import getOne from './get-one'
import create from './create'
import getTaskRecommendations from './get-task-recommendations'
import getCreatives from './get-creatives'
import getResearch from './get-research'
import remove from './delete'
import createRecommendations from './create-recommendations'

const services = {
  get,
  update,
  getOne,
  create,
  delete: remove,
  getTaskRecommendations,
  getCreatives,
  getResearch,
  createRecommendations,
}

export default services
